import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();

  const handleQuoteClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (location.pathname === '/contact') {
      e.preventDefault();
      const formElement = document.getElementById('quote-form-section');
      if (formElement) {
        formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#2B2B2B] text-white overflow-hidden">
      {/* Main Footer */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="min-w-0">
            <img
              src="https://static.readdy.ai/image/6b8c7e9e23efe7296b6664942db70801/c7c219951b750bef5c68afb931877ffb.png"
              alt="Minuu Property Services"
              className="h-20 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm mb-6">
              Professional building services across London
            </p>
          </div>

          {/* Services */}
          <div className="min-w-0">
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services" onClick={handleLinkClick} className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer break-words">
                  General Building
                </Link>
              </li>
              <li>
                <Link to="/services" onClick={handleLinkClick} className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer break-words">
                  Kitchen Refurbishment
                </Link>
              </li>
              <li>
                <Link to="/services" onClick={handleLinkClick} className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer break-words">
                  Bathroom Refurbishment
                </Link>
              </li>
              <li>
                <Link to="/services" onClick={handleLinkClick} className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer break-words">
                  Plumbing
                </Link>
              </li>
              <li>
                <Link to="/services" onClick={handleLinkClick} className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer break-words">
                  Electrical
                </Link>
              </li>
              <li>
                <Link to="/services" onClick={handleLinkClick} className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer break-words">
                  Decorating
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="min-w-0">
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" onClick={handleLinkClick} className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer break-words">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" onClick={handleLinkClick} className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer break-words">
                  Our Process
                </Link>
              </li>
              <li>
                <Link to="/services" onClick={handleLinkClick} className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer break-words">
                  Service Areas
                </Link>
              </li>
              <li>
                <a href="https://www.checkatrade.com/trades/minuupropertyservices" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer break-words">
                  Checkatrade Profile
                </a>
              </li>
              <li>
                <Link to="/contact#quote-form" onClick={handleQuoteClick} className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer break-words">
                  Request a Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="min-w-0">
            <h4 className="text-white font-semibold mb-4">Get in Touch</h4>
            <div className="space-y-3">
              <a href="tel:07773467507" className="block text-lg font-bold text-white hover:text-gray-300 transition-colors cursor-pointer break-words">
                07773 467507
              </a>
              <a href="mailto:enquiries@minuucontractors.co.uk" className="block text-sm text-gray-400 hover:text-white transition-colors cursor-pointer break-all">
                enquiries@minuucontractors.co.uk
              </a>
              <p className="text-sm text-gray-400 break-words">
                London, United Kingdom
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#1F1F1F] py-4">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-400">
            <p className="break-words text-center md:text-left">&copy; 2025 Minuu Property Services. All rights reserved.</p>
            <p className="break-words text-center md:text-right">Part of the Minuu Group</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
